<template>
    <div class="lw-course-contents-chapter mb-6rem" @click="sectionClicked" :class="sectionWrapperClass">
        <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp align-items-stretch">
            <div class="lw-course-contents-chapter-num col span_1_of_12 span_1_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp fsh-0 no-padding">
                <h3 class="fsh-0 learnworlds-heading3 learnworlds-heading3-large no-margin-bottom learnworlds-element">
                    {{sectionNumber}}
                </h3>
            </div>
            <div class="pr-0 col span_11_of_12 span_11_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp lw-bl-3px-fadeout80">
                <div class="with-flexible-parts justify-content-space-between align-items-center">
                    <h3 class="learnworlds-heading3 learnworlds-heading3-large learnworlds-element lw-course-contents-chapter-name no-margin-bottom">{{sectionTitle}}</h3>
                    <div v-if="displayAccessLabel && sectionAccess !== 'premium'" class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDisplayedAccessLabel}}</div>

                    <!-- drip feed -->
                    <div class="ml-20px with-flexible-parts align-items-center" v-if="dripFeedTagsDisplay">
                        <span class="mr-10px small learnworlds-icon no-margin-bottom fas fa-lock"></span>
                        <div class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDripDateLabel}}</div>
                    </div>
                    <!----->

                </div>

                <div v-if="sectionDescription" class="mt-2rem learnworlds-main-text-large">{{ sectionDescription }}</div>

                <div class="lw-course-contents-units mt-2rem">
                    <div class="lw-course-contents-unit with-flexible-parts p-5px-0 justify-content-space-between lw-bb-1px-fadeout90 mb-10px" v-for="unit,index in sectionUnits" @click="unitClicked(unit,...arguments)">
                        <div class="with-flexible-parts align-items-center">
                            <unit-icon class="lw-contents-svg small" :icon="unit.icon"></unit-icon>

                            <div class="ml-10px no-margin-bottom learnworlds-main-text learnworlds-main-text-small learnworlds-element">
                                {{unit.title}}
                            </div>
                            <div class="hide-sp ml-10px no-margin-bottom lw-text-color-fadeout50 learnworlds-main-text learnworlds-main-text-small learnworlds-element" v-if="getFullUnitData(unit) && getUnitExtraInfo(unit)">
                                {{getUnitExtraInfo(unit)}}
                            </div>
                            <span class="ml-10px no-margin-bottom learnworlds-main-text-small learnworlds-icon fas fa-paperclip" v-if="unit.attachments && unit.attachments.length "></span>
                        </div>
                        <span class="ml-10px no-margin-bottom learnworlds-main-text-very-small learnworlds-icon fas fa-check" v-if="unitCompleted(unit)"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CourseContentsTemplateMixin from "../../mixins/CourseContentsTemplateMixin";
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CourseContentsTemplate11",
        mixins: [CourseContentsTemplateMixin,ComponentTemplatesMixin]
    }
</script>

